module.exports = "images/food_bar.bbaad5d8e77dfe2f499bff1882abc989.png";